<template>
    <div class="lookfor">
        <Head :index="'6'"></Head>

        <el-tabs v-model="activeTab" style="padding:0 10px">
            <el-tab-pane label="一键寻祖" name="lookfor">
                <div class="flSearch">
                    <div>本人名： <el-input type="text" v-model="name" autocomplete="off" placeholder="本人姓名"></el-input></div>
                    <div>父亲名：<el-input type="text" v-model="fathername" autocomplete="off" placeholder="父亲姓名"></el-input></div>
                    <el-button @click="searchClick()" type="primary" size="small" style="padding: 12px;width:100%;margin-top:10px">一键寻祖</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="查找共祖" name="cancestor">
                <div class="flSearch">
                    <div class="member-list">
                        <div class="member-row" v-for="(item, index) in info" :key="index">
                            <el-input type="text" class="member-input" v-model="item.name" autocomplete="off" :placeholder="'成员'+(index+1)"></el-input>
                            <el-input type="text" class="member-input" v-model="item.fathername" autocomplete="off" :placeholder="'成员'+(index+1)+'父亲'"></el-input>
                        </div>
                    </div>
                    <div class="member-actions">
                        <el-button type="primary" size="small" @click="add()" :disabled="info.length >= 10">+</el-button>
                        <el-button type="danger" size="small" @click="remove(info.length - 1)" :disabled="info.length <= 2">-</el-button>
                    </div>
                    <el-button @click="searchClick()" type="primary" size="small" style="margin:10px 0;width:100%">查找共祖</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>

        <div class="main fr" ref="chart" v-show="data.length > 0">
            <div id="treeEcharts" style="margin:0 0 0 20px" ref="treeEcharts"></div>
        </div>
    </div>
</template>
<script>

import Head from "@/components/header.vue";
import api from "@/request/api";
export default {
    data() {
        return {
            activeTab: "lookfor",
            fathername: "",
            name: "",
            info: [{"name":"","fathername":""},{"name":"","fathername":""}],
            data: [],
            echartsInit: null
        };
    },
    mounted() {},
    watch: {
        activeTab() {
            this.data = [];
            if (this.echartsInit) {
                this.echartsInit.dispose();
                this.echartsInit = null;
            }
        }
    },
    methods: {
        add() {
            if (this.info.length < 10) {
                this.info.push({"name":"","fathername":""});
            }
        },
        remove(index) {
            if (this.info.length > 2) {
                this.info.splice(index, 1);
            }
        },
        searchClick() {
            if (this.activeTab == "lookfor") {
                api.memberFindancestor(
                    this.$qs.stringify({
                        fid: localStorage.getItem("fid"),
                        name: this.name,
                        fathername: this.fathername
                    })
                ).then((res) => {
                    this.data = res.data;
                    this.$nextTick(() => {
                        this.echartsFun();
                    });
                });
            } else {
                api.memberFindbothancestor({"fid":localStorage.getItem("fid"),"names":this.info}
                ).then((res) => {
                    if (res.code == 0) {
                        this.data = res.data;
                    } else {
                        this.data = [];
                    }
                    this.$nextTick(() => {
                        this.echartsFun();
                    });
                });
            }
        },
        echartsFun() {
            var that = this;
            if (this.echartsInit) {
                this.echartsInit.dispose();
            }
            this.echartsInit = this.$echarts.init(this.$refs.treeEcharts);
            let treeData = this.data;
            this.echartsInit.setOption({
                title: {
                    show: false
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 1,
                            title: "保存为图片 ",
                            type: "png",
                            lang: ["点击保存"],
                            emphasis: {
                                iconStyle: {
                                    textPosition: "left"
                                }
                            }
                        }
                    }
                },
                calculable: false,
                zoom: 0.1,
                series: [
                    {
                        type: "tree",
                        data: treeData,
                        left: "2%",
                        right: "2%",
                        top: "5%",
                        bottom: "20%",
                        symbol: "emptyCircle",
                        orient: "vertical",
                        edgeShape: "polyline",
                        expandAndCollapse: true,
                        roam: true,
                        zoom: 1,
                        initialTreeDepth: -1,
                        expandAndCollapse: false,
                        nodePadding: 10,
                        layerPadding: 10,
                        lineStyle: {
                            color: "red",
                            width: 2
                        },
                        label: {
                            verticalAlign: "middle",
                            show: true,
                            padding: [15, 0],
                            width: 150,
                            height: 60,
                            borderRadius: 10,
                            borderColor: "red",
                            color: "#000000",
                            align: "center",
                            formatter: function(params) {
                                params.data.label = {
                                    backgroundColor: "red"
                                };
                                params.data.label.backgroundColor = params.data.sex == 1 ? "#ffabd5" : "#96d5ff";
                                if (params.data.sgzt == 1) {
                                    params.data.label.borderWidth = 2;
                                    params.data.label.borderColor = "#000";
                                }
                                return (
                                    (params.data.ph != 0 ? "{a|" + that.ph(params.data.ph) + "} " : "") +
                                    "{b|" +
                                    params.data.xm +
                                    "}\n{c|" +
                                    (params.data.dc != "" && params.data.dc != null ? params.data.dc : "未知") +
                                    " - " +
                                    (params.data.jc != "" && params.data.jc != null ? params.data.jc : "至今") +
                                    "}\n{x|" +
                                    that.toChies(params.data.shixu) +
                                    "世}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 10,
                                    borderWidth: 1,
                                    borderColor: "#000",
                                    borderRadius: 50,
                                    padding: 3,
                                    verticalAlign: "top",
                                    align: "center",
                                    lineHeight: 20
                                },
                                b: {
                                    fontSize: 16,
                                    margin: [10, 20]
                                },
                                c: {
                                    fontSize: 12,
                                    color: "#878787",
                                    lineHeight: 30
                                },
                                x: {
                                    fontSize: 12,
                                    color: "#fff"
                                }
                            }
                        },
                        leaves: {
                            label: {
                                verticalAlign: "middle",
                                align: "center"
                            }
                        },
                        animationDurationUpdate: 250
                    }
                ]
            });

            const getLevel = (arr) => {
                let maxLevel = 0;
                (function callBack(arr, level) {
                    ++level;
                    maxLevel = Math.max(level, maxLevel);
                    for (let i = 0; i < arr.length; i++) {
                        let item = arr[i];
                        if (item.children && item.children.length > 0) {
                            callBack(item.children, level);
                        } else {
                            delete item.children;
                        }
                    }
                })(arr, 0);
                return maxLevel;
            };
            function getMaxFloor(arr) {
                let maxLevel = [];
                (function callBack(arr, level) {
                    for (let i = 0; i < arr.length; i++) {
                        let item = arr[i];
                        if (item.children && item.children.length > 0) {
                            callBack(item.children, level);
                        } else {
                            maxLevel.push(item);
                        }
                    }
                })(arr, 0);
                return maxLevel;
            }

            const height = window.innerHeight;
            const width = window.innerWidth;
            const currentHeight = 170 * getLevel(treeData);
            let currentWidth = 200 * getMaxFloor(treeData).length;
            if (currentWidth > width - 400) {
                currentWidth = 380;
            }
            const newHeight = Math.max(currentHeight, height - 115);
            const tree_ele = document.getElementById("treeEcharts");
            tree_ele.style.height = newHeight + "px";
            tree_ele.style.width = currentWidth + "px";

            this.echartsInit.resize();

            this.echartsInit.on("treeroam", function(params) {
                if (params.originX || params.originY) {
                    let zoom = params.zoom;
                    let _option = that.echartsInit.getOption();
                    let series = _option.series[0];
                    series.label.padding[0] = series.label.padding[0] * zoom;
                    series.label.padding[1] = series.label.padding[1] * zoom;
                    series.label.height = series.label.height * zoom;
                    series.label.width = series.label.width * zoom;
                    series.label.borderRadius = series.label.borderRadius * zoom;
                    series.label.rich.a.fontSize = series.label.rich.a.fontSize * zoom;
                    series.label.rich.a.lineHeight = series.label.rich.a.lineHeight * zoom;
                    series.label.rich.a.padding = series.label.rich.a.padding * zoom;
                    series.label.rich.b.fontSize = series.label.rich.b.fontSize * zoom;
                    series.label.rich.b.margin[0] = series.label.rich.b.margin[0] * zoom;
                    series.label.rich.b.margin[1] = series.label.rich.b.margin[1] * zoom;
                    series.label.rich.c.fontSize = series.label.rich.c.fontSize * zoom;
                    series.label.rich.c.lineHeight = series.label.rich.c.lineHeight * zoom;
                    series.label.rich.x.fontSize = series.label.rich.x.fontSize * zoom;
                    that.echartsInit.setOption(_option);
                }
            });
        }
    },
    computed: {
        ph() {
            return function(val) {
                let ph = "";
                for (let i = 0; i < this.$store.state.phData.length; i++) {
                    if (val == this.$store.state.phData[i].val) {
                        ph = this.$store.state.phData[i].key;
                    }
                }
                return ph;
            };
        },
        toChies() {
            return function(val) {
                return this.$utils.toChies(val);
            };
        }
    },
    components: {
        Head
    }
};
</script>

<style lang="less" scoped>
.lookfor {
    height: 100%;

    .flSearch {
        width: 100%;
        font-size: 14px;
        padding: 10px;
        box-sizing: border-box;
        div {
            margin-bottom: 10px;
        }
        .el-input {
            width: 120px;
            font-size: 1rem;
            /deep/.el-input__inner {
                padding: 0 10px !important;
            }
        }
        .member-list {
            width: 100%;

            .member-row {
                display: flex;
                align-items: center;
                gap: 6px;
                margin-bottom: 10px;

                .member-input {
                    flex: 1;
                    min-width: 0;

                    /deep/ .el-input {
                        width: 100%;
                    }
                }
            }

            .member-actions {
                display: flex;
                gap: 10px;
                justify-content: center;
                margin-top: 10px;

                .el-button {
                    width: 80px;
                }
            }

        }
        /deep/.el-input {
            .el-input__inner {
                border-width: 3px !important;
                font-size: 14px;
            }
        }
    }

    .main {
        text-align: center;
        overflow: auto;
        > div {
            width: 100%;
            height: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/lookfor.vue